import React, {Component} from 'react';
import SquareButton from "../../../components/SquareButton";

class UserBranchInfo extends Component {

	constructor(props) {
		super(props);

		this.state = {
			isMobile : window.innerWidth > 991 ? false : true
		};
	}

	render() {
		const { isMobile } = this.state;
		return (
			<div style={{margin: '30px 0px 30px 30px'}}>

				{!isMobile && <div className="col-sm-12" style={{textAlign: 'right'}}>
					<SquareButton title='Değiştir' img='edit.png'
								  style={{background: 'linear-gradient(rgba(154, 193, 218, 0.61), #6e8da2)', float: 'right',}}
								  onClick={this.props.openActiveBranchModal}/>
				</div>}

				<div className='col-sm-12 row'>
					<div className='col sm-5 pt-1'>
						<h6 className="card-title" style={{textTransform: 'none'}}>Aktif Şube:</h6>
					</div>

					<div className='col sm-7'>
						<label className='col-form-label' style={{marginBottom: '20px'}}>{this.props.activeBranchToShow}</label>
					</div>
				</div>



				{(this.props.activeBranchOtherInfo && this.props.activeBranchOtherInfo.activeBranchEmail) &&
				<div className='col-sm-12 row'>
					<div className='col sm-5'>
						<label className='col-form-label' style={{fontWeight: 'bold'}}>e-Posta: </label>
					</div>
					<div className='col sm-7'>
						<label className='col-form-label'>{this.props.activeBranchOtherInfo && this.props.activeBranchOtherInfo.activeBranchEmail}</label>
					</div>
				</div>}

				{(this.props.activeBranchOtherInfo && this.props.activeBranchOtherInfo.activeBranchPhone) &&
				<div className='col-sm-12 row' style={{padding:  '0 0 0 25px'}}>
					<div className='col sm-5' style={{paddingRight: '0'}}>
						<label className='col-form-label' style={{fontWeight: 'bold'}}>Telefon: </label>
					</div>
					<div className='col sm-7'>
						<label className='col-form-label'>{this.props.activeBranchOtherInfo && this.props.activeBranchOtherInfo.activeBranchPhone}</label>
					</div>
				</div>}

				{(this.props.activeBranchOtherInfo && this.props.activeBranchOtherInfo.activeBranchFax) &&
				<div className='col-sm-12 row' style={{padding:  '0 0 0 25px'}}>
					<div className='col sm-5' style={{paddingRight: '0'}}>
						<label className='col-form-label' style={{fontWeight: 'bold'}}>Fax: </label>
					</div>
					<div className='col sm-7'>
						<label className='col-form-label'>{this.props.activeBranchOtherInfo && this.props.activeBranchOtherInfo.activeBranchFax}</label>
					</div>
				</div>}

				{isMobile && <div className="col-sm-12" style={{textAlign: 'right',padding:'20px 40px 20px 0px'}}>
					<SquareButton title='Değiştir' img='edit.png'
								  style={{background: 'linear-gradient(rgba(154, 193, 218, 0.61), #6e8da2)', float: 'right'}}
								  onClick={this.props.openActiveBranchModal}/>
				</div>}

				{/*{(this.props.activeBranchOtherInfo && this.props.activeBranchOtherInfo.activeBranchGbAlias) &&*/}
				{/*<div className='col-sm-6 row' style={{padding:  '0 0 0 25px'}}>*/}
					{/*<div className='col-sm-5' style={{paddingRight: '0'}}>*/}
						{/*<label className='col-form-label' style={{fontWeight: 'bold'}}>Gönderici Etiketi: </label>*/}
					{/*</div>*/}
					{/*<div className='col-sm-7'>*/}
						{/*<label className='col-form-label'>{this.props.activeBranchOtherInfo && this.props.activeBranchOtherInfo.activeBranchGbAlias}</label>*/}
					{/*</div>*/}
				{/*</div>}*/}

				{/*{(this.props.activeBranchOtherInfo && this.props.activeBranchOtherInfo.activeBranchPkAlias) &&*/}
				{/*<div className='col-sm-6 row' style={{padding:  '0 0 0 25px'}}>*/}
					{/*<div className='col-sm-5' style={{paddingRight: '0'}}>*/}
						{/*<label className='col-form-label' style={{fontWeight: 'bold'}}>Alıcı Etiketi: </label>*/}
					{/*</div>*/}
					{/*<div className='col-sm-7'>*/}
						{/*<label className='col-form-label'>{this.props.activeBranchOtherInfo && this.props.activeBranchOtherInfo.activeBranchPkAlias}</label>*/}
					{/*</div>*/}
				{/*</div>}*/}
			</div>
		)
	}
}

export default UserBranchInfo;